const productData = [
  {
    id: 1,
    slug: "sunday-supper-seasoning",
    name: "Sunday Supper Seasoning",
    category: "Blends",
    price: 8.95,
    image: "/assets/products/sunday-supper-seasoning.png",
    images: ["/assets/products/sunday-supper-seasoning.png"],
    description:
      "A tomato-rich, garlicky blend with sweet pepper and herbs for pasta sauce, meatballs, roasted vegetables, and the meals that gather everyone around the table.",
    attributes: {
      flavor: "Savory, tomato-forward, herbal",
      heat: "Mild",
      origin: "Blended in Wisconsin",
      ingredients: "Tomato, garlic, sweet paprika, oregano, basil, black pepper",
    },
    tags: ["everyday", "salt-free", "pasta", "vegetables"],
    variants: [
      { id: "1-jar", label: "2.4 oz jar", weight: "2.4 oz", price: 8.95, stock: 48 },
      { id: "1-bag", label: "6 oz refill", weight: "6 oz", price: 15.95, stock: 31 },
    ],
    rating: 4.9,
    reviews: 284,
    featured: true,
    bestSeller: true,
    stock: 79,
  },
  {
    id: 2,
    slug: "fireside-smoky-rub",
    name: "Fireside Smoky Rub",
    category: "Blends",
    price: 9.45,
    compareAtPrice: 10.95,
    image: "/assets/products/fireside-smoky-rub.png",
    images: ["/assets/products/fireside-smoky-rub.png"],
    description:
      "Smoked paprika, toasted cumin, and a touch of maple sugar create a deep crust on ribs, chicken, mushrooms, and cast-iron potatoes.",
    attributes: {
      flavor: "Smoky, earthy, lightly sweet",
      heat: "Medium",
      origin: "Blended in Wisconsin",
      ingredients: "Smoked paprika, cumin, maple sugar, garlic, ancho chile, sea salt",
    },
    tags: ["grilling", "barbecue", "smoky", "summer"],
    variants: [
      { id: "2-jar", label: "2.8 oz jar", weight: "2.8 oz", price: 9.45, stock: 42 },
      { id: "2-bag", label: "7 oz refill", weight: "7 oz", price: 17.5, stock: 20 },
    ],
    rating: 4.8,
    reviews: 196,
    featured: true,
    bestSeller: true,
    stock: 62,
  },
  {
    id: 3,
    slug: "garden-table-herb-blend",
    name: "Garden Table Herb Blend",
    category: "Blends",
    price: 8.75,
    image: "/assets/products/garden-table-herb-blend.png",
    images: ["/assets/products/garden-table-herb-blend.png"],
    description:
      "A bright salt-free mix of parsley, chives, dill, thyme, and lemon peel for salad dressings, eggs, fish, and creamy dips.",
    attributes: {
      flavor: "Green, fresh, lemony",
      heat: "None",
      origin: "Blended in Wisconsin",
      ingredients: "Parsley, chives, dill, thyme, lemon peel, white pepper",
    },
    tags: ["salt-free", "herbs", "salad", "seafood"],
    variants: [
      { id: "3-jar", label: "1.1 oz jar", weight: "1.1 oz", price: 8.75, stock: 37 },
      { id: "3-bag", label: "3 oz refill", weight: "3 oz", price: 14.25, stock: 22 },
    ],
    rating: 4.7,
    reviews: 128,
    featured: false,
    bestSeller: false,
    stock: 59,
  },
  {
    id: 4,
    slug: "northwoods-roast-blend",
    name: "Northwoods Roast Blend",
    category: "Blends",
    price: 9.25,
    image: "/assets/products/northwoods-roast-blend.png",
    images: ["/assets/products/northwoods-roast-blend.png"],
    description:
      "Juniper, rosemary, pepper, and garlic give slow roasts, root vegetables, and hearty bean stews a woodsy, aromatic finish.",
    attributes: {
      flavor: "Piney, peppery, savory",
      heat: "Mild",
      origin: "Blended in Wisconsin",
      ingredients: "Rosemary, black pepper, garlic, juniper, thyme, mustard",
    },
    tags: ["roasting", "winter", "beef", "root-vegetables"],
    variants: [
      { id: "4-jar", label: "2.2 oz jar", weight: "2.2 oz", price: 9.25, stock: 29 },
      { id: "4-bag", label: "5 oz refill", weight: "5 oz", price: 16.5, stock: 18 },
    ],
    rating: 4.8,
    reviews: 151,
    featured: true,
    bestSeller: false,
    stock: 47,
  },
  {
    id: 5,
    slug: "high-meadow-rosemary",
    name: "High Meadow Rosemary",
    category: "Herbs",
    price: 7.25,
    image: "/assets/products/high-meadow-rosemary.png",
    images: ["/assets/products/high-meadow-rosemary.png"],
    description:
      "Fragrant, needle-cut rosemary selected for its clean evergreen aroma and gentle citrus finish in breads, potatoes, poultry, and beans.",
    attributes: {
      flavor: "Evergreen, woody, citrusy",
      form: "Needle cut",
      origin: "Mediterranean coast",
      ingredients: "Rosemary",
    },
    tags: ["single-origin", "herbs", "bread", "roasting"],
    variants: [
      { id: "5-jar", label: "1 oz jar", weight: "1 oz", price: 7.25, stock: 51 },
      { id: "5-bag", label: "3 oz refill", weight: "3 oz", price: 12.95, stock: 26 },
    ],
    rating: 4.7,
    reviews: 89,
    featured: false,
    bestSeller: false,
    stock: 77,
  },
  {
    id: 6,
    slug: "summer-leaf-basil",
    name: "Summer Leaf Basil",
    category: "Herbs",
    price: 7.45,
    image: "/assets/products/summer-leaf-basil.png",
    images: ["/assets/products/summer-leaf-basil.png"],
    description:
      "Large, softly crumbled basil leaves with a sweet anise aroma, dried quickly to keep their vivid garden character.",
    attributes: {
      flavor: "Sweet, leafy, softly anise-like",
      form: "Rubbed leaves",
      origin: "Aegean region",
      ingredients: "Basil",
    },
    tags: ["herbs", "tomato", "pesto", "mediterranean"],
    variants: [
      { id: "6-jar", label: "0.7 oz jar", weight: "0.7 oz", price: 7.45, stock: 46 },
      { id: "6-bag", label: "2 oz refill", weight: "2 oz", price: 12.5, stock: 24 },
    ],
    rating: 4.8,
    reviews: 112,
    featured: false,
    bestSeller: true,
    stock: 70,
  },
  {
    id: 7,
    slug: "woodland-rubbed-sage",
    name: "Woodland Rubbed Sage",
    category: "Herbs",
    price: 7.75,
    image: "/assets/products/woodland-rubbed-sage.png",
    images: ["/assets/products/woodland-rubbed-sage.png"],
    description:
      "Velvety rubbed sage with a mellow, resinous fragrance made for brown butter, squash, stuffing, breakfast sausage, and white beans.",
    attributes: {
      flavor: "Earthy, savory, gently minty",
      form: "Rubbed leaves",
      origin: "Adriatic highlands",
      ingredients: "Sage",
    },
    tags: ["herbs", "holiday", "poultry", "squash"],
    variants: [
      { id: "7-jar", label: "0.8 oz jar", weight: "0.8 oz", price: 7.75, stock: 35 },
      { id: "7-bag", label: "2 oz refill", weight: "2 oz", price: 13.25, stock: 17 },
    ],
    rating: 4.6,
    reviews: 76,
    featured: false,
    bestSeller: false,
    stock: 52,
  },
  {
    id: 8,
    slug: "sunfield-golden-turmeric",
    name: "Sunfield Golden Turmeric",
    category: "Spices",
    price: 8.25,
    image: "/assets/products/sunfield-golden-turmeric.png",
    images: ["/assets/products/sunfield-golden-turmeric.png"],
    description:
      "Deep golden turmeric with a warm earthiness and clean finish for curries, lentils, rice, soups, and honeyed morning drinks.",
    attributes: {
      flavor: "Earthy, warm, lightly bitter",
      form: "Fine ground",
      origin: "Tamil Nadu, India",
      ingredients: "Turmeric",
    },
    tags: ["single-origin", "curry", "vegan", "golden-milk"],
    variants: [
      { id: "8-jar", label: "2.3 oz jar", weight: "2.3 oz", price: 8.25, stock: 62 },
      { id: "8-bag", label: "6 oz refill", weight: "6 oz", price: 14.95, stock: 33 },
    ],
    rating: 4.9,
    reviews: 203,
    featured: true,
    bestSeller: true,
    stock: 95,
  },
  {
    id: 9,
    slug: "harvest-sweet-paprika",
    name: "Harvest Sweet Paprika",
    category: "Spices",
    price: 8.45,
    image: "/assets/products/harvest-sweet-paprika.png",
    images: ["/assets/products/harvest-sweet-paprika.png"],
    description:
      "Brilliant red sweet pepper ground to a silky powder, adding round fruitiness and color to chicken, potatoes, sauces, and stews.",
    attributes: {
      flavor: "Sweet, fruity, round",
      form: "Fine ground",
      origin: "Szeged, Hungary",
      ingredients: "Sweet red pepper",
    },
    tags: ["single-origin", "paprika", "stew", "color"],
    variants: [
      { id: "9-jar", label: "2.5 oz jar", weight: "2.5 oz", price: 8.45, stock: 55 },
      { id: "9-bag", label: "7 oz refill", weight: "7 oz", price: 15.75, stock: 28 },
    ],
    rating: 4.8,
    reviews: 174,
    featured: false,
    bestSeller: true,
    stock: 83,
  },
  {
    id: 10,
    slug: "toasted-coriander-seed",
    name: "Toasted Coriander Seed",
    category: "Spices",
    price: 7.95,
    image: "/assets/products/toasted-coriander-seed.png",
    images: ["/assets/products/toasted-coriander-seed.png"],
    description:
      "Whole coriander seeds gently toasted for a citrusy, nutty aroma that blooms beautifully in curries, pickles, roasted carrots, and grilled meats.",
    attributes: {
      flavor: "Citrusy, nutty, floral",
      form: "Whole seed",
      origin: "Rajasthan, India",
      ingredients: "Coriander seed",
    },
    tags: ["whole-spice", "pickling", "curry", "toasting"],
    variants: [
      { id: "10-jar", label: "1.5 oz jar", weight: "1.5 oz", price: 7.95, stock: 43 },
      { id: "10-bag", label: "4 oz refill", weight: "4 oz", price: 13.5, stock: 19 },
    ],
    rating: 4.7,
    reviews: 93,
    featured: false,
    bestSeller: false,
    stock: 62,
  },
  {
    id: 11,
    slug: "ironwood-black-pepper",
    name: "Ironwood Black Pepper",
    category: "Pepper & Chiles",
    price: 9.95,
    image: "/assets/products/ironwood-black-pepper.png",
    images: ["/assets/products/ironwood-black-pepper.png"],
    description:
      "Bold whole peppercorns with lively citrus and cedar notes, selected for the table grinder and any dish that deserves a fragrant final crack.",
    attributes: {
      flavor: "Pungent, citrusy, woody",
      form: "Whole peppercorn",
      origin: "Malabar Coast, India",
      ingredients: "Black peppercorns",
    },
    tags: ["single-origin", "pepper", "pantry", "grinder"],
    variants: [
      { id: "11-jar", label: "2.2 oz jar", weight: "2.2 oz", price: 9.95, stock: 64 },
      { id: "11-bag", label: "6 oz refill", weight: "6 oz", price: 18.25, stock: 30 },
    ],
    rating: 4.9,
    reviews: 341,
    featured: true,
    bestSeller: true,
    stock: 94,
  },
  {
    id: 12,
    slug: "copper-trail-chile-flakes",
    name: "Copper Trail Chile Flakes",
    category: "Pepper & Chiles",
    price: 8.95,
    image: "/assets/products/copper-trail-chile-flakes.png",
    images: ["/assets/products/copper-trail-chile-flakes.png"],
    description:
      "Sun-dried chile flakes with a warm, gradual heat and berry-like sweetness for pizza, noodles, braises, and roasted greens.",
    attributes: {
      flavor: "Fruity, warm, lightly smoky",
      heat: "Medium-hot",
      origin: "New Mexico, USA",
      ingredients: "Dried red chile",
    },
    tags: ["chile", "pizza", "heat", "vegan"],
    variants: [
      { id: "12-jar", label: "1.7 oz jar", weight: "1.7 oz", price: 8.95, stock: 49 },
      { id: "12-bag", label: "4 oz refill", weight: "4 oz", price: 15.25, stock: 21 },
    ],
    rating: 4.8,
    reviews: 167,
    featured: false,
    bestSeller: true,
    stock: 70,
  },
  {
    id: 13,
    slug: "embers-edge-chile-powder",
    name: "Ember's Edge Chile Powder",
    category: "Pepper & Chiles",
    price: 9.25,
    image: "/assets/products/embers-edge-chile-powder.png",
    images: ["/assets/products/embers-edge-chile-powder.png"],
    description:
      "A balanced ground chile blend that layers ancho sweetness, chipotle smoke, and a spark of cayenne into tacos, chili, beans, and marinades.",
    attributes: {
      flavor: "Smoky, raisiny, savory",
      heat: "Hot",
      origin: "Blended in Wisconsin",
      ingredients: "Ancho chile, chipotle, cayenne, cumin, garlic",
    },
    tags: ["chile", "tacos", "hot", "smoky"],
    variants: [
      { id: "13-jar", label: "2.1 oz jar", weight: "2.1 oz", price: 9.25, stock: 39 },
      { id: "13-bag", label: "5 oz refill", weight: "5 oz", price: 16.75, stock: 15 },
    ],
    rating: 4.7,
    reviews: 142,
    featured: false,
    bestSeller: false,
    stock: 54,
  },
  {
    id: 14,
    slug: "midnight-cocoa-blend",
    name: "Midnight Cocoa Blend",
    category: "Baking",
    price: 10.95,
    image: "/assets/products/midnight-cocoa-blend.png",
    images: ["/assets/products/midnight-cocoa-blend.png"],
    description:
      "A plush blend of natural and Dutch-process cocoa with espresso powder for brownies, cakes, hot chocolate, and deeply chocolate cookies.",
    attributes: {
      flavor: "Dark chocolate, roasted, smooth",
      form: "Fine powder",
      origin: "Blended in Wisconsin",
      ingredients: "Cocoa powder, Dutch-process cocoa, espresso powder",
    },
    tags: ["baking", "chocolate", "dessert", "cocoa"],
    variants: [
      { id: "14-jar", label: "4 oz jar", weight: "4 oz", price: 10.95, stock: 44 },
      { id: "14-bag", label: "12 oz refill", weight: "12 oz", price: 21.5, stock: 20 },
    ],
    rating: 4.9,
    reviews: 238,
    featured: true,
    bestSeller: true,
    stock: 64,
  },
  {
    id: 15,
    slug: "orchard-pie-spice",
    name: "Orchard Pie Spice",
    category: "Baking",
    price: 8.75,
    image: "/assets/products/orchard-pie-spice.png",
    images: ["/assets/products/orchard-pie-spice.png"],
    description:
      "Cinnamon, ginger, cardamom, and allspice tuned for apple pie, baked oats, fruit crisps, pancakes, and buttery shortbread.",
    attributes: {
      flavor: "Warm, sweet, gently floral",
      form: "Fine ground",
      origin: "Blended in Wisconsin",
      ingredients: "Cinnamon, ginger, cardamom, allspice, nutmeg",
    },
    tags: ["baking", "fall", "pie", "breakfast"],
    variants: [
      { id: "15-jar", label: "2 oz jar", weight: "2 oz", price: 8.75, stock: 53 },
      { id: "15-bag", label: "5 oz refill", weight: "5 oz", price: 15.5, stock: 27 },
    ],
    rating: 4.8,
    reviews: 185,
    featured: false,
    bestSeller: true,
    stock: 80,
  },
  {
    id: 16,
    slug: "cloudforest-cinnamon",
    name: "Cloudforest Cinnamon",
    category: "Baking",
    price: 9.45,
    image: "/assets/products/cloudforest-cinnamon.png",
    images: ["/assets/products/cloudforest-cinnamon.png"],
    description:
      "A soft, fragrant cinnamon with honeyed citrus notes and gentle warmth, ground fresh for toast, pastry, coffee, and savory braises.",
    attributes: {
      flavor: "Honeyed, citrusy, mellow",
      form: "Fine ground",
      origin: "Central highlands, Vietnam",
      ingredients: "Cinnamon",
    },
    tags: ["single-origin", "baking", "cinnamon", "coffee"],
    variants: [
      { id: "16-jar", label: "2.4 oz jar", weight: "2.4 oz", price: 9.45, stock: 57 },
      { id: "16-bag", label: "7 oz refill", weight: "7 oz", price: 17.95, stock: 25 },
    ],
    rating: 4.9,
    reviews: 267,
    featured: true,
    bestSeller: true,
    stock: 82,
  },
  {
    id: 17,
    slug: "sunlit-lemon-pepper",
    name: "Sunlit Lemon Pepper",
    category: "Citrus & Aromatics",
    price: 8.95,
    image: "/assets/products/sunlit-lemon-pepper.png",
    images: ["/assets/products/sunlit-lemon-pepper.png"],
    description:
      "Real lemon peel, cracked black pepper, garlic, and herbs make an energetic finishing blend for fish, chicken, asparagus, and vinaigrettes.",
    attributes: {
      flavor: "Bright, peppery, savory",
      heat: "Mild",
      origin: "Blended in Wisconsin",
      ingredients: "Lemon peel, black pepper, garlic, parsley, sea salt",
    },
    tags: ["citrus", "seafood", "chicken", "finishing"],
    variants: [
      { id: "17-jar", label: "2.5 oz jar", weight: "2.5 oz", price: 8.95, stock: 47 },
      { id: "17-bag", label: "6 oz refill", weight: "6 oz", price: 16.25, stock: 23 },
    ],
    rating: 4.8,
    reviews: 158,
    featured: true,
    bestSeller: false,
    stock: 70,
  },
  {
    id: 18,
    slug: "candied-ginger-dust",
    name: "Candied Ginger Dust",
    category: "Citrus & Aromatics",
    price: 9.75,
    image: "/assets/products/candied-ginger-dust.png",
    images: ["/assets/products/candied-ginger-dust.png"],
    description:
      "Fine ginger balanced with cane sugar and lemon for sprinkling over cookies, fruit, oatmeal, buttered toast, and sparkling drinks.",
    attributes: {
      flavor: "Zesty, sweet, lemony",
      form: "Fine ground",
      origin: "Blended in Wisconsin",
      ingredients: "Ginger, cane sugar, lemon peel",
    },
    tags: ["ginger", "baking", "beverages", "finishing"],
    variants: [
      { id: "18-jar", label: "2.8 oz jar", weight: "2.8 oz", price: 9.75, stock: 31 },
      { id: "18-bag", label: "7 oz refill", weight: "7 oz", price: 17.75, stock: 14 },
    ],
    rating: 4.7,
    reviews: 104,
    featured: false,
    bestSeller: false,
    stock: 45,
  },
  {
    id: 19,
    slug: "weeknight-essentials-set",
    name: "Weeknight Essentials Set",
    category: "Gift Sets",
    price: 34,
    compareAtPrice: 39.8,
    image: "/assets/products/weeknight-essentials-set.png",
    images: ["/assets/products/weeknight-essentials-set.png"],
    description:
      "Four dependable jars for quick, deeply flavored dinners: Sunday Supper, Garden Table Herbs, Sunfield Turmeric, and Ironwood Black Pepper.",
    attributes: {
      includes: "Four full-size jars",
      packaging: "Recyclable kraft gift box",
      occasion: "Housewarming or new kitchen",
      ingredients: "See individual jar labels",
    },
    tags: ["gift", "starter-set", "weeknight", "best-value"],
    variants: [
      { id: "19-box", label: "4-jar gift box", weight: "14 oz", price: 34, stock: 24 },
    ],
    rating: 4.9,
    reviews: 119,
    featured: true,
    bestSeller: true,
    stock: 24,
  },
  {
    id: 20,
    slug: "bakers-warmth-collection",
    name: "Baker's Warmth Collection",
    category: "Gift Sets",
    price: 38,
    image: "/assets/products/bakers-warmth-collection.png",
    images: ["/assets/products/bakers-warmth-collection.png"],
    description:
      "A giftable trio of Cloudforest Cinnamon, Orchard Pie Spice, and Midnight Cocoa, plus a small maplewood measuring spoon.",
    attributes: {
      includes: "Three full-size jars and measuring spoon",
      packaging: "Printed keepsake box",
      occasion: "Bakers, holidays, host gifts",
      ingredients: "See individual jar labels",
    },
    tags: ["gift", "baking", "holiday", "host"],
    variants: [
      { id: "20-box", label: "3-jar gift box", weight: "15 oz", price: 38, stock: 19 },
    ],
    rating: 4.8,
    reviews: 87,
    featured: true,
    bestSeller: false,
    stock: 19,
  },
  {
    id: 21,
    slug: "grill-and-glow-set",
    name: "Grill & Glow Set",
    category: "Gift Sets",
    price: 36,
    compareAtPrice: 41.5,
    image: "/assets/products/grill-and-glow-set.png",
    images: ["/assets/products/grill-and-glow-set.png"],
    description:
      "Fireside Smoky Rub, Copper Trail Chile Flakes, Ember's Edge Chile Powder, and Sunlit Lemon Pepper packed for open-flame cooks.",
    attributes: {
      includes: "Four full-size jars",
      packaging: "Recyclable kraft gift box",
      occasion: "Grill lovers and summer hosts",
      ingredients: "See individual jar labels",
    },
    tags: ["gift", "grilling", "summer", "spicy"],
    variants: [
      { id: "21-box", label: "4-jar gift box", weight: "16 oz", price: 36, stock: 17 },
    ],
    rating: 4.8,
    reviews: 73,
    featured: false,
    bestSeller: false,
    stock: 17,
  },
  {
    id: 22,
    slug: "everyday-garlic-granules",
    name: "Everyday Garlic Granules",
    category: "Essentials",
    price: 7.95,
    image: "/assets/products/everyday-garlic-granules.png",
    images: ["/assets/products/everyday-garlic-granules.png"],
    description:
      "Slow-dried garlic granules with a round, mellow savor that disperses evenly through soups, marinades, dressings, and skillet meals.",
    attributes: {
      flavor: "Savory, mellow, lightly sweet",
      form: "Granulated",
      origin: "California, USA",
      ingredients: "Garlic",
    },
    tags: ["pantry", "garlic", "everyday", "salt-free"],
    variants: [
      { id: "22-jar", label: "2.7 oz jar", weight: "2.7 oz", price: 7.95, stock: 68 },
      { id: "22-bag", label: "8 oz refill", weight: "8 oz", price: 14.75, stock: 36 },
    ],
    rating: 4.9,
    reviews: 292,
    featured: false,
    bestSeller: true,
    stock: 104,
  },
  {
    id: 23,
    slug: "mineral-sea-salt-flakes",
    name: "Mineral Sea Salt Flakes",
    category: "Essentials",
    price: 8.5,
    image: "/assets/products/mineral-sea-salt-flakes.png",
    images: ["/assets/products/mineral-sea-salt-flakes.png"],
    description:
      "Delicate, crisp salt flakes with clean minerality for finishing tomatoes, eggs, roasted vegetables, caramel, and warm bread.",
    attributes: {
      flavor: "Clean, mineral, saline",
      form: "Pyramid flakes",
      origin: "Pacific coast, USA",
      ingredients: "Sea salt",
    },
    tags: ["salt", "finishing", "pantry", "baking"],
    variants: [
      { id: "23-jar", label: "3 oz jar", weight: "3 oz", price: 8.5, stock: 58 },
      { id: "23-bag", label: "8 oz refill", weight: "8 oz", price: 15.95, stock: 29 },
    ],
    rating: 4.8,
    reviews: 181,
    featured: false,
    bestSeller: false,
    stock: 87,
  },
  {
    id: 24,
    slug: "stoneground-mustard-powder",
    name: "Stoneground Mustard Powder",
    category: "Essentials",
    price: 8.25,
    image: "/assets/products/stoneground-mustard-powder.png",
    images: ["/assets/products/stoneground-mustard-powder.png"],
    description:
      "Finely milled yellow mustard seed with clean tang and gentle warmth for vinaigrettes, cheese sauces, dry rubs, pickles, and deviled eggs.",
    attributes: {
      flavor: "Tangy, nutty, warming",
      form: "Fine ground",
      origin: "Canadian prairie",
      ingredients: "Yellow mustard seed",
    },
    tags: ["mustard", "pantry", "pickling", "sauce"],
    variants: [
      { id: "24-jar", label: "2 oz jar", weight: "2 oz", price: 8.25, stock: 41 },
      { id: "24-bag", label: "5 oz refill", weight: "5 oz", price: 14.5, stock: 18 },
    ],
    rating: 4.7,
    reviews: 98,
    featured: false,
    bestSeller: false,
    stock: 59,
  },
];

export default productData;
